import { sendRequest } from './index';
import { API_PHARMA_JOBS_URL } from '@core/constants/API';

export const JobsPharmaJobs = {
    GET: (filters) => {
        const queryParams = Object.keys(filters).reduce((searchparams, currentKey) => {
            if (filters[currentKey] !== '') {
                if (searchparams.length === 0) {
                    return `?${currentKey}=${filters[currentKey]}`;
                } else {
                    return searchparams + `&${currentKey}=${filters[currentKey]}`;
                }
            } else {
                return searchparams;
            }
        }, '');
        return sendRequest({
            url: `${API_PHARMA_JOBS_URL}jobs${queryParams}`,
            method: 'GET'
        });
    }
};

export const jobsFav = {
    POST: (id) => {
        return sendRequest({
            url: `${API_PHARMA_JOBS_URL}jobs/${id}/favorites`,
            method: 'POST'
        });
    },
    DELETE: (id) => {
        return sendRequest({
            url: `${API_PHARMA_JOBS_URL}jobs/${id}/favorites`,
            method: 'DELETE'
        });
    },
};

export const jobsJob = {
    GET: (id) => {
        return sendRequest({
            url: `${API_PHARMA_JOBS_URL}jobs/${id}`,
            method: 'GET'
        });
    }
};

export const jobsApply = {
    GET: (id) => {
        return sendRequest({
            url: `${API_PHARMA_JOBS_URL}jobs/${id}/apply`,
            method: 'GET'
        });
    }
};

export const jobAlert = {
    GET: () => {
        return sendRequest({
            url: `${API_PHARMA_JOBS_URL}job-alerts/me`,
            method: 'GET'
        });
    },
    PUT: (payload) => {
        return sendRequest({
            url: `${API_PHARMA_JOBS_URL}job-alerts/me`,
            method: 'PUT',
            body: payload
        });
    },
    DELETE: () => {
        return sendRequest({
            url: `${API_PHARMA_JOBS_URL}job-alerts/me`,
            method: 'DELETE'
        });
    },
};